import { render, staticRenderFns } from "./AssetFavorite.vue?vue&type=template&id=352799b7&"
import script from "./AssetFavorite.vue?vue&type=script&lang=js&"
export * from "./AssetFavorite.vue?vue&type=script&lang=js&"
import style0 from "./AssetFavorite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports